import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WarehouseRestockType } from '../../enums/warehouse-restock-type';
import { WarehouseRestockTypePipe } from '../../pipes/warehouse-restock-type.pipe';

@Component({
  selector: 'app-warehouse-restock-type',
  imports: [CommonModule, WarehouseRestockTypePipe],
  templateUrl: './warehouse-restock-type.component.html',
  styleUrl: './warehouse-restock-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseRestockTypeComponent {
  public readonly type = input.required<WarehouseRestockType>();
}
